<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <card>
        <div
          class="col-md-12 col-lg-12 col-sm-12"
          role="dialog"
          aria-labelledby="modalTitle"
          aria-describedby="modalDescription"
        >
          <div class="modal-body">
            <div>
              <div class="row align-items-center justify-content-between mb-3">
                <h4
                  slot="header"
                  id="modalTitle"
                  class="card-title text-align-center"
                >
                  {{ `${titulo} Vendedor` }}
                </h4>

                <button
                  v-if="this.action === 'EDIT'"
                  class="btn btn-icon btn-info"
                  @click="copiarUrl()"
                >
                  <i class="fa fa-external-link" aria-hidden="true"></i>
                </button>
              </div>

              <form id="modalDescription">
                <div class="row pl-3">
                  <base-input
                    type="text"
                    id="name"
                    label="Nome"
                    v-model="vendedor.name"
                    @input="validaCampos()"
                    @change="validaCampos()"
                  ></base-input>
                  <base-input
                    type="text"
                    label="Telefone"
                    id="phone"
                    v-model="vendedor.phone"
                    @input="validaCampos()"
                    @change="
                      validaCampos();
                      maskPhone(vendedor.phone);
                    "
                    maxlength="14"
                    v-on:keyup="maskPhone(vendedor.phone)"
                  ></base-input>
                </div>

                <hr />
                <label for="anuncioImagem">Foto</label>
                <div class="row pl-3 align-items-center">
                  <button
                    id="upload_widget"
                    class="d-inline"
                    @click.prevent="uploadImage"
                    v-if="!vendedor.image"
                  >
                    Selecionar imagem
                  </button>
                  <div class="d-inline align-self-center" v-if="vendedor.image">
                    <img
                      :src="vendedor.image"
                      alt="Foto do perfil"
                      id="profile-photo"
                    />
                    <button
                      class="btn btn-icon btn-danger ml-2"
                      @click.prevent="deleteImage()"
                    >
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </div>
                </div>
                <div class="text-center mt-4">
                  <button
                    type="submit"
                    class="btn btn-success btn-fill float-right"
                    @click.prevent="salvarVendedor"
                    :disabled="erroValidacao"
                  >
                    <i class="fa fa-floppy-o" aria-hidden="true"></i> Salvar
                  </button>
                  <button
                    @click.prevent
                    class="btn btn-danger btn-fill float-left"
                    @click="close"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i> Fechar
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>
            </div>
          </div>
        </div>
      </card>
    </div>
  </transition>
</template>

<script>
import Card from 'src/components/Cards/Card.vue';
import VendedoresServices from 'src/services/vendedores';
import _ from 'lodash';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

export default {
  components: {
    Card
  },
  props: {
    afterCreateAction: Function,
    action: String,
    code: String
  },
  data() {
    return {
      notifications: {
        topCenter: false
      },
      simple: '',
      name: 'modal',
      erroValidacao: true,
      vendedor: {
        name: '',
        code: '',
        image: '',
        phone: ''
      }
    };
  },
  computed: {
    titulo() {
      if (this.action === 'EDIT') {
        return 'Editar';
      } else if (this.action === 'NEW') {
        return 'Cadastrar';
      }
    },
    hasUrlFoto() {
      return this.vendedor && this.vendedor.image;
    }
  },
  methods: {
    salvarVendedor() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Salvo com Sucesso',
          'fa fa-check'
        );
        this.vendedor = {
          name: '',
          code: '',
          image: '',
          phone: ''
        };
        this.afterCreateAction();
        this.close();
        loader.hide();
      };

      const errorCallback = err => {
        const message =
          _.get(err, 'response.status') === 400 &&
          _.has(err, 'response.data.message')
            ? _.get(err, 'response.data.message')
            : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

        this.notifyVue(
          'top',
          'center',
          'danger',
          message,
          'fa fa-exclamation-triangle'
        );
        loader.hide();
      };

      const vendedor = {
        ...this.vendedor,
        phone: this.vendedor.phone.replace(/[^0-9]/g, '')
      };

      if (vendedor._id) {
        VendedoresServices.atualizar(vendedor)
          .then(sucessCallback)
          .catch(errorCallback);
      } else {
        VendedoresServices.salvar({
          ...vendedor,
          code: undefined
        })
          .then(sucessCallback)
          .catch(errorCallback);
      }
    },
    close() {
      this.$emit('close');
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    uploadImage() {
      // eslint-disable-next-line no-undef
      const myWidget = cloudinary.createUploadWidget(
        {
          cloudName: 'dy8mstmqs',
          uploadPreset: 'afqwmioy',
          sources: ['local'],
          maxFiles: 1,
          apiKey: '456183971343259'
        },
        (error, result) => {
          if (!error && result && result.event === 'success') {
            this.vendedor.image = result.info.url;
            const name = this.vendedor.name;
            this.vendedor.name = name + ' ';
            this.vendedor.name = name;
            this.validaCampos();
          }
        }
      );
      myWidget.open();
    },
    deleteImage() {
      this.vendedor.image = '';
      const name = this.vendedor.name;
      this.vendedor.name = name + ' ';
      this.vendedor.name = name;
    },
    validaCampos() {
      if (
        this.vendedor.name == '' ||
        !this.vendedor.name ||
        this.vendedor.image == '' ||
        !this.vendedor.image ||
        this.vendedor.phone == '' ||
        !this.vendedor.phone
      ) {
        this.erroValidacao = true;
      } else this.erroValidacao = false;
    },
    copiarUrl() {
      const link = `http://proposta-comercial.joule.eco.br/?seller=${this.vendedor.code}`;
      const fallbackMessage = () => {
        this.notifyVue(
          'top',
          'center',
          'warning',
          `Não foi possível copiar automaticamente. Link para cópia manual: ${link}`,
          'fa fa-exclamation-triangle'
        );
      };
      try {
        let textArea = document.createElement('textarea');
        textArea.value = link;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
          document.execCommand('copy') ? res() : rej();
          textArea.remove();

          this.notifyVue(
            'top',
            'center',
            'success',
            'Link copiado com sucesso',
            'fa fa-check'
          );
        });
      } catch (e) {
        fallbackMessage();
      }
    },
    maskPhone(phone) {
      phone = phone.replace(/\D/g, '');
      phone = phone.replace(/^(\d)/, '($1');
      phone = phone.replace(/(.{3})(\d)/, '$1)$2');
      if (phone.length == 9) {
        phone = phone.replace(/(.{1})$/, '-$1');
      } else if (phone.length == 10) {
        phone = phone.replace(/(.{2})$/, '-$1');
      } else if (phone.length == 11) {
        phone = phone.replace(/(.{3})$/, '-$1');
      } else if (phone.length == 12) {
        phone = phone.replace(/(.{4})$/, '-$1');
      } else if (phone.length > 12) {
        phone = phone.replace(/(.{4})$/, '-$1');
      }
      this.vendedor.phone = phone;
    }
  },
  watch: {
    code: {
      immediate: true,
      handler(code) {
        if (code) {
          const loader = this.$loading.show({
            color: VUE_APP_SPINNER_COLOR
          });

          const errorCallback = err => {
            const message =
              _.get(err, 'response.status') === 400 &&
              _.has(err, 'response.data.message')
                ? _.get(err, 'response.data.message')
                : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

            this.notifyVue(
              'top',
              'center',
              'danger',
              message,
              'fa fa-exclamation-triangle'
            );
            loader.hide();
          };

          VendedoresServices.get({ code })
            .then(response => {
              this.vendedor = _.get(response, 'data');
              this.validaCampos();
              this.maskPhone(this.vendedor.phone);
              loader.hide();
            })
            .catch(errorCallback);
        } else {
          this.vendedor = {
            image: '',
            name: '',
            code: '',
            phone: ''
          };
        }
      }
    }
  }
};
</script>
<style scoped>
.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

#modalDescription {
  width: 350px;
}

.modal-body {
  position: relative;
}

#profile-photo {
  width: 7em;
  height: 7em;
}

#upload_widget {
  max-height: 30px;
}

.form-group {
  width: 100%;
}
</style>
